// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2Jjfa","option":"styles_option__37p7o","active":"styles_active__3ee7C","badge":"styles_badge__22rG5","inner":"styles_inner__1kdO5"};